import { render, staticRenderFns } from "./Auth_Screen_ForgotPassword.vue?vue&type=template&id=8b56f08c&"
import script from "./Auth_Screen_ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./Auth_Screen_ForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports